import { useEffect, useState } from 'react'
import { Modal } from 'components'
import ErrorMessage from 'components/forms/error-message'
import { lang } from 'config'
import _ from 'lodash'
import { Plus } from 'components/icons/outline'
import axios from 'axios'
import { toast } from 'react-hot-toast'
import nProgress from 'nprogress'
import Label from 'components/forms/label'
import useAttributeGroupRepositories from 'repositories/attribute-group'
import useAttributeRepositories from 'repositories/attribute'
import InputDate from 'components/forms/input-date'
import moment from 'moment'
import InputAmount from 'components/forms/input-amount'
import useDiscountRepositories from 'repositories/discount'
import useBranchRepositories from 'repositories/branch'
import SelectDescription from 'components/forms/select-description'
import { useAuth } from 'contexts/auth-context'

// Opsi "Terapkan ke Harga" (apply_to). Value HARUS persis price/store_price/both agar cocok dengan backend.
const APPLY_TO_OPTIONS = [
    { id: 'price', name: 'Harga Normal' },
    { id: 'store_price', name: 'Harga Toko (POS)' },
    { id: 'both', name: 'Keduanya' },
]

const Content = ({ data, onSubmit }) => {

    const { isSuper, currentBranch } = useAuth()
    const isSup = isSuper()

    const { data: branchSelection, isLoading: isLoadingBranch } = useBranchRepositories({ paginate: false })

    const [discount, setDiscount] = useState()
    const [discountId, setDiscountId] = useState()
    const [outletId, setOutletId] = useState(isSup ? undefined : currentBranch?.id)
    const [applyTo, setApplyTo] = useState()
    const [from, setFrom] = useState()
    const [to, setTo] = useState()

    // ATALLA-371: pilih outlet dulu, baru daftar diskon dimuat SESUAI outlet terpilih
    // (params null = fetch ditunda, sama dengan pola halaman Apply Diskon).
    const { data: discountSelection, isLoading: isLoadingDiscountSelection } = useDiscountRepositories(outletId ? {
        paginate: false,
        order_by: "name",
        direction: "asc",
        outlet_id: outletId
    } : null)

    // Ganti outlet → reset pilihan diskon supaya tidak nyangkut diskon milik outlet lain.
    useEffect(() => {
        setDiscountId(undefined)
        setDiscount(undefined)
    }, [outletId])

    const [excluded, setExcluded] = useState([])

    const [errors, setErrors] = useState({})

    useEffect(() => {
        if (discountId && !isLoadingDiscountSelection) {
            setDiscount(discountSelection?.find((row) => row.id === discountId))
        }
    }, [discountId, isLoadingDiscountSelection])

    useEffect(() => {
        if (data) {
            var excludes = []
            console.log(data,"datamonyr")
            data.filter(row => row.outlet_id && row.outlet_id === currentBranch?.id).forEach((row) => {
                const start = new Date(row.from_date)
                const end = new Date(row.to_date)

                excludes.push({ start: start.setDate(start.getDate() - 1), end })
            })

            setExcluded(excludes)
        }
    }, [data])

    const handleSubmit = (e) => {
        e.preventDefault()
        const selectedDiscount = discountSelection?.find((item) => item.id === discountId)

        if (!selectedDiscount || !outletId || !applyTo || !from || !to) {
            setErrors({
                discount_type_id: !selectedDiscount ? ["Discount wajib dipilih"] : undefined,
                outlet_id: !outletId ? ["Outlet wajib dipilih"] : undefined,
                apply_to: !applyTo ? ["Terapkan ke harga wajib dipilih"] : undefined,
                from_date: !from ? ["Tanggal mulai wajib diisi"] : undefined,
                to_date: !to ? ["Tanggal akhir wajib diisi"] : undefined,
            })
            toast.error("Lengkapi data discount terlebih dahulu")
            return
        }

        if (!nProgress.isStarted()) {
            nProgress.start()

            toast.loading("Memuat", {
                id: "submit"
            })

            const outlet_id = outletId;
            axios.post(`${process.env.REACT_APP_INVENTORY_API_URL}/product/unit/validate`, {
                type: 'discount',
                discount_type_id: discountId,
                from_date: from,
                to_date: to
            }).then((response) => {
                toast.success(response.data.message, {
                    id: "submit"
                })

                onSubmit({
                    discount,
                    outlet_id,
                    apply_to: applyTo,
                    from_date: from,
                    to_date: to
                })

                nProgress.done()
            }).catch((error) => {
                if (error?.response?.status === 422) {
                    setErrors(error?.response?.data?.errors || {})
                }
                toast.error(error?.response?.data?.message || "Gagal apply discount", {
                    id: "submit"
                })

                nProgress.done()
            })
        } else {
            toast.error("Aksi sebelumnya sedang dimuat")
        }
    }

    return (
        <div className="mt-8 space-y-8">
            <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <Label htmlFor="outlet" value="Outlet" />
                        <SelectDescription onChange={(value) => setOutletId(value)} selection={branchSelection} isLoading={isLoadingBranch} value={outletId} keyValue={(value) => value.id} title={(value) => value.name} placeholder="Pilih Outlet" error={errors.outlet_id} />
                        <ErrorMessage error={errors.outlet_id} />
                    </div>

                    <div>
                        <Label htmlFor="discount" value="Diskon" />
                        <SelectDescription onChange={(value) => setDiscountId(value)} selection={discountSelection ?? []} isLoading={outletId ? isLoadingDiscountSelection : false} value={discountId} keyValue={(value) => value.id} title={(value) => value.name} placeholder={outletId ? "Pilih Diskon" : "Pilih Outlet Terlebih Dahulu"} error={errors.discount_type_id} disabled={!outletId} />
                        <ErrorMessage error={errors.discount_type_id} />
                    </div>

                    <div>
                        <Label htmlFor="apply_to" value="Terapkan ke Harga" />
                        <SelectDescription onChange={(value) => setApplyTo(value)} selection={APPLY_TO_OPTIONS} value={applyTo} keyValue={(value) => value.id} title={(value) => value.name} placeholder="Pilih Harga" error={errors.apply_to} />
                        <ErrorMessage error={errors.apply_to} />
                    </div>

                    <div></div>

                    <div>
                        <Label htmlFor="from" value="Dari" />
                        <InputDate excludeDateIntervals={excluded} error={errors.from_date} id="from" maxDate={Date.parse(to)} onChange={(value) => setFrom(moment(value).format('Y-MM-DD'))} value={Date.parse(from)} selected={Date.parse(from)} />
                        <ErrorMessage error={errors.from_date} />
                    </div>

                    <div>
                        <Label htmlFor="to" value="To" />
                        <InputDate excludeDateIntervals={excluded} error={errors.to_date} id="to" minDate={Date.parse(from)} onChange={(value) => setTo(moment(value).format('Y-MM-DD'))} value={Date.parse(to)} selected={Date.parse(to)} />
                        <ErrorMessage error={errors.to_date} />
                    </div>
                </div>
            </div>
            <div className="text-xs">
                <button onClick={handleSubmit} className="items-center px-6 py-3 text-white transition bg-brand-800 rounded-xl active:hover:scale-90">
                    <span>{lang.save}</span>
                </button>
            </div>
        </div>
    )
}

const Add = ({ data, onSubmit }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSubmit = (data) => {
        onSubmit(data)

        closeModal()
    }

    return (
        <>
            <button type="button" onClick={openModal} className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90">
                <Plus className="w-4 h-4" stroke={1.5} />
                <span>{lang.create}</span>
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.create} ${lang.data}`} content={<Content data={data} onSubmit={handleSubmit} />} />
        </>
    )
}

export default Add
